import { Delete, Edit } from '@mui/icons-material';
import { Divider, IconButton, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { EliminarFotoInstalacion, ObtenerDatosInstalacion } from '../../helpers/ActivosHelper'
import { ActivosContext } from '../../pages/catalogos/ActivosPage';
import { ModalEliminaInstalacionComponent } from './ModalEliminaInstalacionComponent';

export const DatosInstalacionComponent = ({instalacion}) => {
    const [datosInstalacion, setDatosInstalacion] = useState();
    const {activos, instalacionEditando, setInstalacionEditando, modalAgregaActivo, setModalAgregaActivo, editandoInstalacion, setEditandoInstalacion, setActivoSeleccionado} = useContext(ActivosContext);
    const [modalEliminaInstalacion, setModalEliminaInstalacion] = useState(false);
    useEffect(() => {
        console.log('datos instalacion',instalacion);
        obtenerDatosInstalacion();
    }, [instalacion])

    const obtenerDatosInstalacion =() => {
        console.log('obteniendo datos de instalacion', instalacion?.key)
        ObtenerDatosInstalacion(instalacion?.key).then(datos=>setDatosInstalacion(datos));
    }

    
    useEffect(() => {
        obtenerDatosInstalacion();
    }, [])

    useEffect(() => {
        console.log('cambio el modal agrega activo')
        obtenerDatosInstalacion();
    }, [modalAgregaActivo])
    

    
    const detalleInstalacion = (dato, valor) => {
        return (
            <div
            style={{
                display:'flex',
                flexDirection:'row',
                fontSize:12
            }}
        >
            <div
                style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:20,
                    fontWeight:500
                }}
            >
                {dato}
            </div>
            <div
                style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:70
                }}
            >
                {valor}
            </div>
        </div>

        )
    }

  return (
    <>
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            padding:15
        }}
    >
        <div
            style={{
                backgroundColor:'white',
                boxShadow:  '1px 2px 9px #0f0f0f',
                padding:10,
                borderRadius:10
            }}
        >
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between'
                }}
            >
                <Typography
                    style={{
                        fontSize:20,
                        fontWeight:600
                    }}
                >

                    {instalacion?.title}
                </Typography>
                <div>
                    <IconButton
                        onClick={() => {setInstalacionEditando(datosInstalacion); setEditandoInstalacion(true); setModalAgregaActivo(true)}}
                    >
                        <Edit
                            style={{
                                color:'green'
                            }}
                        />
                    </IconButton>
                    <IconButton
                        onClick={() => {setInstalacionEditando(datosInstalacion); setModalEliminaInstalacion(true)}}
                    >
                        <Delete
                            style={{
                                color:'red'
                            }}
                        />
                    </IconButton>
                </div>
            </div>
            <Divider />
            { detalleInstalacion('Tipo de Instalación', datosInstalacion?.TipoInstalacion)}
            { detalleInstalacion('Capítulo', datosInstalacion?.descripcion)}
            { detalleInstalacion('Siglas', datosInstalacion?.Siglas)}
            { detalleInstalacion('Marca', datosInstalacion?.Marca)}
            { detalleInstalacion('Modelo', datosInstalacion?.Modelo)}
            { detalleInstalacion('Número de Inventario', datosInstalacion?.NumeroInventario)}
            { detalleInstalacion('Número de Serie', datosInstalacion?.NumeroSerie)}
        </div>
    </div>
    <ModalEliminaInstalacionComponent modalEliminaInstalacion={modalEliminaInstalacion} setModalEliminaInstalacion={setModalEliminaInstalacion} datosInstalacion={datosInstalacion} />
    </>
  )
}
